import {
    Component, Input, OnInit
} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { getWindow } from 'ssr-window';
import { HttpErrorResponse } from '@angular/common/http';
import { CfAlertService } from '@crediblefinance/credible-ui';
import { KycService } from '../../services/kyc.service';

@Component({
    selector: 'app-airdrop-kyc',
    templateUrl: './airdrop-kyc.component.html',
    styleUrls: [ './airdrop-kyc.component.scss' ]
})
export class AirdropKycComponent implements OnInit {
    @Input() task = {
        id: '',
        title: '',
        desc: '',
        icon: '',
        status: 'Pending',
        reward: 0,
        multiplier: false,
        redirect_url: '',
        cta: '',
        coming_soon: false
    };

    constructor(public httpService: HttpService,
        private kycService: KycService,
        private cfAlertService: CfAlertService
    ) {
        this.window = getWindow();
    }

    window: Window;
    kyc_loading: boolean = false;

    ngOnInit(): void {
        this.attachSocketEvents();
    }

    attachSocketEvents() {

    }
    
    generateKycUrl() {
        // this.cfAlertService.showMessage('System is under maintenance.', true);

        // return;

        this.kyc_loading = true;

        this.kycService.generateKycUrl(this.httpService.user).subscribe((res: any) => {
            this.kyc_loading = false;

            this.window.location.href = res.data;
        }, (err: HttpErrorResponse) => {
            console.error(err);

            this.kyc_loading = false;

            this.cfAlertService.showError(err);
        });
    }
}
